(function() {
    const pfb = {
        _isLoading: false,
        _nextPage: 2,
        _productUrl: '',
      __totalPage:0,
        _productView: 4,
        _scrollTrigger: $('#shopify-section-collection-template .collection-list.hasNext'),
        init: function() {
            this.initInfiniteLoading();
        },
        initInfiniteLoading: function() {
        
         
             if ( pfb._scrollTrigger.length > 0  ) {
            $(window).on('scroll', function(e) {
           
              	let scrollTrigger = pfb._scrollTrigger.offset().top + pfb._scrollTrigger.innerHeight();
                let windowPosition = $(this).scrollTop() + (window.innerHeight);

              if(pfb._nextPage != pfb.__totalPage){
                if ( windowPosition >= (scrollTrigger - 400)  && ! pfb._isLoading ) {
                 console.log('Next--product--0scrollTrigger',scrollTrigger)
                    pfb.getNextProducts(pfb._nextPage, pfb._productView);
                }
            }
               
            });
          }
       
         
        },
      // (scrollTrigger - 400)
        getNextProducts: function(page, view) {
   console.time();
            let queryParams = [
                {
                    name: 'page',
                    value: page
                },
                {
                    name: 'view',
                    value: view
                }
            ]

            this._productUrl = this.setQueryStringParameter(queryParams);
     
            $.ajax({
                url: this._productUrl,
                type: "GET",
                beforeSend: function() {
					pfb._isLoading = true
                   pfb._scrollTrigger.addClass('products_loading')
              	},
                success: function (data) {

                    var productItems = $(data).find(".grid__item.item-row");
                  pfb.__totalPage = productItems.length;
                    productItems.each(function(index) {
                        $('.products-grid-view ul').append(this);
                    })

                 pfb._scrollTrigger.removeClass('products_loading')
					pfb._isLoading = false
                    pfb._nextPage++;
                           
                },
                error: function (xhr, exception) {
                    var msg = "";
                    if (xhr.status === 0) {
                        msg = "Not connect.\n Verify Network." + xhr.responseText;
                    } else if (xhr.status == 404) {
                        msg = "Requested page not found. [404]" + xhr.responseText;
                    } else if (xhr.status == 500) {
                        msg = "Internal Server Error [500]." +  xhr.responseText;
                    } else if (exception === "parsererror") {
                        msg = "Requested JSON parse failed.";
                    } else if (exception === "timeout") {
                        msg = "Time out error." + xhr.responseText;
                    } else if (exception === "abort") {
                        msg = "Ajax request aborted.";
                    } else {
                        msg = "Error:" + xhr.status + " " + xhr.responseText;
                    }
                }
            })

        },
        setQueryStringParameter: function(queryParams) {
            const params = new URLSearchParams(window.location.search);

            queryParams.map((query) => {
                params.set(query.name, query.value );
            });

            return decodeURIComponent(`${window.location.pathname}?${params}`);
        }
    }
    
    $(document).ready(function() {
		pfb.init();
      
      jQuery('.main-slideshow').slick({
        centerMode: true,
        centerPadding: '550px',
        autoplay: true,
        autoplaySpeed: 2000,
        infinite: true,
        arrows: true,
        asNavFor: '#slider-thumbs',
        // appendArrows: '.quotes-arrow-1568358362991-nav',
        prevArrow: '<a class="prev-arrow"><i class="fas fa-arrow-left" aria-hidden="true"></i></a>',
        nextArrow: '<a class="next-arrow"><i class="fas fa-arrow-right" aria-hidden="true"></i></a>',
        slidesToShow: 1,
        slidesToScroll: 1,
        Speed:2000,
        responsive: [
          {
            breakpoint: 1800,
            settings: {
              centerPadding: '400px',
              slidesToShow: 1,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 1399,
            settings: {
              centerPadding: '350px',
              slidesToShow: 1,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 1199,
            settings: {
              centerPadding: '0',
              slidesToShow: 1,
              slidesToScroll: 1
            }
          },
          {
          breakpoint: 480,
          settings: {
            centerMode: false,
            slidesToShow: 1,
            slidesToScroll: 1
          }
          }
        ]
       });
      
      
      jQuery('#slider-thumbs').slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        infinite: true,
        centerMode: true,
        centerPadding: '0px',
        asNavFor: '.variable-width',
        dots: false,
        focusOnSelect: true,
        autoplay:false,
        arrows: false,
        autoplaySpeed:4000,
        responsive: [
          {
            breakpoint:968,
            settings: {
              centerMode: true,
              centerPadding: 'true',
              slidesToShow: 3,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 568,
            settings: {
              centerMode: true,
              centerPadding: 'true',
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      });
      jQuery('.slick-slide').on('click', function() {
        const toGoSlide = jQuery(this).data('slick-index')
        const currentSlide = jQuery('.main-slideshow').slick('slickCurrentSlide')

        if ( toGoSlide > currentSlide ) {
            jQuery('.main-slideshow').slick('slickNext');
        } else {
            jQuery('.main-slideshow').slick('slickPrev');
        }
      })
    })
})(jQuery)
